var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"files__file-item"},[_c('a',{staticClass:"files__file-body",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.downloadFile(_vm.file)}}},[_c('r-icon',{staticClass:"files__file-icon",attrs:{"name":"acts-document","size":32}}),_c('r-text',{staticClass:"files__file-name"},[_vm._v(_vm._s(_vm.file.filename))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }